import { themeParams, useSignal } from "@telegram-apps/sdk-react";
import { Image, PullToRefresh } from "antd-mobile";
import { PullStatus } from "antd-mobile/es/components/pull-to-refresh";
import LightLogo from "~/assets/imgs/logo-svg-light.svg";
import DarkLogo from "~/assets/imgs/logo-svg-dark.svg";
import LightLogoGif from "~/assets/imgs/launch_light.gif";
import DarkLogoGif from "~/assets/imgs/launch_dark.gif";

export interface PageProps {
    onRefresh: () => Promise<unknown>;
}

const PullToRefreshStatus: React.FC<{ status: PullStatus }> = ({ status }) => {
    const isDark = useSignal(themeParams.isDark);

    return (
        <Image
            src={
                status === "refreshing"
                    ? isDark
                        ? DarkLogoGif
                        : LightLogoGif
                    : isDark
                      ? DarkLogo
                      : LightLogo
            }
            width={80}
            height={30}
        />
    );
};

const PullToRefreshPage: React.FC<React.PropsWithChildren<PageProps>> = ({
    onRefresh,
    children,
}) => {
    return (
        <PullToRefresh
            renderText={(status) => <PullToRefreshStatus status={status} />}
            onRefresh={onRefresh}
        >
            {children}
        </PullToRefresh>
    );
};

export default PullToRefreshPage;
